import {
    ADD_PERMISSION_FAIL,
    ADD_PERMISSION_SUCCESS,
    DELETE_PERMISSION_FAIL,
    DELETE_PERMISSION_SUCCESS,
    EXPORT_PERMISSION_FAIL,
    EXPORT_PERMISSION_SUCCESS,
    GET_PERMISSION_DETAILS_FAIL,
    GET_PERMISSION_DETAILS_SUCCESS,
    GET_PERMISSION_LISTING_FAIL,
    GET_PERMISSION_LISTING_SUCCESS,
    RESET_PERMISSION_STATE,
    UPDATE_PERMISSION_FAIL,
    UPDATE_PERMISSION_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    permissionListing: [],
    permissionDetails: [],
    addPermission: [],
    updatePermission: [],
    deletePermission: [],
    exportPermission: [],
    error: [],
}

const Permission = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PERMISSION_LISTING_SUCCESS:
            return {
                ...state,
                permissionListing: action.payload
            }
        case GET_PERMISSION_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_PERMISSION_DETAILS_SUCCESS:
            return {
                ...state,
                permissionDetails: action.payload
            }
        case GET_PERMISSION_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_PERMISSION_SUCCESS:
            return {
                ...state,
                addPermission: action.payload
            }
        case ADD_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_PERMISSION_SUCCESS:
            return {
                ...state,
                updatePermission: action.payload
            }
        case UPDATE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_PERMISSION_SUCCESS:
            return {
                ...state,
                deletePermission: action.payload
            }
        case DELETE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_PERMISSION_SUCCESS:
            return {
                ...state,
                exportPermission: action.payload
            }
        case EXPORT_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_PERMISSION_STATE:
            return {
                ...state,
                permissionListing: [],
                permissionDetails: [],
                addPermission: [],
                updatePermission: [],
                deletePermission: [],
                exportPermission: [],
                error: [],
            }
        default:
            return state
    }
}

export default Permission
